export default __webpack_public_path__ + "static/media/clifford.872d704a.jpg";